var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledStar = function SvgFilledStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1719_220186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1719_220186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.0624L6.5834 16.1041C6.43062 16.1874 6.28132 16.2221 6.13548 16.2083C5.98965 16.1944 5.86118 16.1458 5.75007 16.0624C5.63895 15.9791 5.55562 15.8645 5.50007 15.7187C5.44451 15.5728 5.43757 15.4235 5.47923 15.2708L6.37507 11.4583L3.35423 8.89575C3.22923 8.78464 3.15284 8.65617 3.12507 8.51034C3.09729 8.3645 3.10423 8.22214 3.1459 8.08325C3.18757 7.94436 3.26395 7.82978 3.37507 7.7395C3.48618 7.64922 3.62507 7.59714 3.79173 7.58325L7.75007 7.22909L9.31256 3.60409C9.38201 3.45131 9.47923 3.33672 9.60423 3.26034C9.72923 3.18395 9.86118 3.14575 10.0001 3.14575C10.139 3.14575 10.2709 3.18395 10.3959 3.26034C10.5209 3.33672 10.6181 3.45131 10.6876 3.60409L12.2501 7.24992L16.2084 7.58325C16.3751 7.59714 16.514 7.6527 16.6251 7.74992C16.7362 7.84714 16.8126 7.9652 16.8542 8.10409C16.8959 8.24297 16.8994 8.38186 16.8646 8.52075C16.8299 8.65964 16.7501 8.78464 16.6251 8.89575L13.6251 11.4583L14.5209 15.2708C14.5626 15.4235 14.5556 15.5728 14.5001 15.7187C14.4445 15.8645 14.3612 15.9791 14.2501 16.0624C14.139 16.1458 14.0105 16.1944 13.8646 16.2083C13.7188 16.2221 13.5695 16.1874 13.4167 16.1041L10.0001 14.0624Z",
    fill: "#5998F8"
  }))));
};
export default SvgFilledStar;